import React from 'react';
import {FSMStore} from 'webgl/stores';
import {FSMStates} from 'webgl/types/FSMStates';
import './Credits.scss';

const Credits: React.FC = () => {
  const currentFSMState = FSMStore(state => state.currentFSMState);
  const setFSMState = FSMStore(state => state.setFSMState);

  if (currentFSMState !== FSMStates.webgl.benefices &&
    currentFSMState !== FSMStates.webgl.risques &&
    currentFSMState !== FSMStates.webgl.solutions) return null;

  return (
    <div className={'credits'}>
      <button onClick={() => setFSMState(FSMStates.webgl.main_sub.credits, true)}>Crédits</button>
    </div>
  );
};

export default Credits;
